// ONLY MODIFY THIS FILE BY RUNNING THE FOLLOWING COMMAND:
// php artisan react:enum

export const NotificationChannelType = {
  Phone: {
    Name: 'Phone',
    Value: 'phone',
    Icon: 'Phone',
  },
  Text: {
    Name: 'Text',
    Value: 'text',
    Icon: 'MessageSquare',
  },
  Email: {
    Name: 'Email',
    Value: 'email',
    Icon: 'Mail',
  },
  Fax: {
    Name: 'Fax',
    Value: 'fax',
    Icon: 'Printer',
  },
} as const

export type NotificationChannelTypeValue =
  (typeof NotificationChannelType)[keyof typeof NotificationChannelType]['Value']
